export default "__VITE_ASSET__3zFlP8YD__"